/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, May 2020
 */

/**
 * Populate an array with a value.
 *
 * @param array Array to populate.
 * @param value Value to populate with.
 * @param start The index to start populating.
 * @param end Index where the last element will be inserted.
 */
export function fill<T>(array: T[], value: T, start = 0, end = array.length): T[] {
    for (let i = start; i <= end; i += 1) {
        array[i] = value;
    }
    return array;
}



// WEBPACK FOOTER //
// ./src/packages/core/lib/objects/fill.ts